<template>
    <!--桌邊點餐 菜單-->
    <div class="order-list home" :class="{ 'openBox': isActive }" @scroll="scrollEvent" ref="order">
        <div class="topNav">
            <navigation-bar Back Order :isCheckBack="true" :storeId="id" v-if="isCordova || isOnlineOrder"/>
            <navigation-bar Order Delete :storeId="id" :params="{...dataObject}" v-else-if="isTableOrderAddItem" @triggerEvent="navigationBarEvent"/>
            <navigation-bar Back :storeId="id" v-else/>
        </div>

        <!--todo 選擇其他時間餐期-->
        <div class="top-pick-time" v-if="isCordova || isOnlineOrder" @click="openPickTime">{{storeInfo.reservationTitle}} <i class="el-icon-arrow-right"/></div>
        <pick-time v-if="isOpenPickTime" :value="isOpenPickTime" @result="closePickTime"/>
        <Banner id="bannerBrand" :storeId="id" :storeImage="storeImage"/>
        <div class="top-branch">{{brandName}}-{{storeName}}{{tableNo !== '' ? `（桌號：${tableNo}）` : ''}}</div>
        <template v-if="posMenuData.length===0">
            <div class="no-data">
                <img src="../../assets/images/dialog-order.svg" alt="沒有餐點">
                <div class="mt-3" v-html="nextTimeTip"/>
            </div>
        </template>
        <nav class="side-bar" v-else>
            <div class="content" ref="sideBar">
                <a v-for="(item, index) in posMenuList" :key="index" :class="{'active':selectedTab===index}" ref="nav" @click="changeMenu(index)">
                    {{item.name}}
                </a>
            </div>
        </nav>

        <!--TODO 店家公告-->
        <Remind v-if="isAnnouncement && posMenuData.length!==0 " :announcement="announcement"></Remind>

        <div ref="meals" class="meals">
            <h4 v-if="false" class="order-title">{{menuName}}</h4>
            <!--TODO 餐點列表-->
            <div v-for="(item, index) in posMenuData" :key="index" :data-food-id="item.posFoodId">
                <div v-if="index === 0 || (index > 0 && posMenuData[index].posMenuTypeId !== posMenuData[index-1].posMenuTypeId)"
                     class="big-title" ref="anchorId">
                    <h2 class="m-0">{{item.posMenuTypeName}}</h2>
                </div>
                <Menu v-if="typeof takeAmountMapMeal[index] !== 'number' || takeAmountMapMeal[index] === 0" :storeId="id" :item="item" :takeoutId="takeoutId" :ref="'posFoodId_'+item.posFoodId" @triggerEvent="menuEvent($event, item, index)"></Menu>
                <Menu v-else :item="item" :takeoutId="takeoutId" :takeAmount="takeAmountMapMeal[index]" :ref="'posFoodId_'+item.posFoodId" @triggerEvent="menuEvent($event, item, index)"></Menu>
            </div>
        </div>

        <comm-dialog :value="isShowDialog"
                     :outerContent="'有尚未完成的訂單'"
                     :mainContent="'確定離開？'"
                     :isCancel="true"
                     @result="onCommDialogClose"/>

        <comm-dialog :value="isShowClearCartDialog"
                     :outerContent="'是否清空購物車資料？'"
                     :isCancel="true"
                     @result="onCommClearCartDialogClose"/>

        <el-dialog
            class="dialog"
            :visible.sync="isShowCheckDialog"
            :show-close="false"
            top="40%"
            width="80%"
            custom-class="commDialog">
            <div class="container" id="commDialogContainer">
                <img src="../../assets/images/dialog_cart.svg" class="icon">
                <span class="main-content mt-0">你已選擇了不同品牌，如要繼續<br>您的購物車將被清空</span>
                <div class="dialog-footer">
                    <el-button round type="primary" @click="isShowCheckDialog = false">關閉</el-button>
                    <el-button round type="info" @click="clearCart(true)">是</el-button>
                </div>
            </div>
        </el-dialog>

        <infinite-loading v-if="setupDataScroll" spinner="waveDots" @infinite="setupDataScrollAct">
        <div slot="no-more">沒有更多資料</div>
        <div slot="no-results"></div>
        </infinite-loading>

        <!--TODO 候位預約點餐出現區塊-->
        <cart-button toCart v-if="false"/>
        <!--TODO 線上點餐出現區塊-->
        <cart-button toCart
                     :takeoutId="takeoutId"
                     :totalPrice="totalPrice"
                     :totalAmount="totalAmount"
                     v-if="totalAmount>0"
                     :storeId="cartStoreId"
                     :brandName="brandName"
                     :storeName="storeName"/>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>
</template>

<script>
import CartButton from '@/views/order/components/CartButton';
import Menu from '@/views/order/components/Menu';
import Banner from '@/views/order/components/Banner';
import Remind from '@/views/order/components/Remind';
import {notNull} from '@/util/common';
import CommDialog from "@/components/CommDialog";
import PickTime from "./components/PickTime";
import * as mutationTypes from "@/store/mutationTypes";
import utilDate from "@/util/date";
import * as constDefine from "@/store/constDefine";
import Analytics from '@/util/analytics';

export default {
    name: "OrderList",
    components: {
        CartButton,
        Menu,//菜單
        Banner,//最上方商家橫幅＋星號
        Remind,//小提醒區塊
        CommDialog,
        PickTime, //選擇其他時間週期
    },
    data() {
        return {
            isActive: false,
            //joinTeam: true,

            isLoading: false,
            setupDataScroll: false,
            infiniteLoadingListState: '',
            currentPage: 0,
            pageSize: 10,
            id: Number(this.$route.query.id),
            takeoutId: this.$route.query.takeoutId?Number(this.$route.query.takeoutId): 0,
            posMenuId: 0,
            storeImage: '',
            brandName: '',
            storeName: '',
            isAnnouncement: false,
            announcement: '',
            posMenuTypeId: 0,
            selectedTab: 0,
            menuName: '',
            posMenuList: [],
            posMenuData: [],
            nextTimeTip:'',     //沒有當前餐期時顯示下一個餐期時間提示文字
            takeAmountMapMeal: {},
            totalPrice: 0,
            totalAmount: 0,
            scrollTop: '',
            scrollHeight: '',
            scrollLeft: '',
            cartStoreId: this.$store.state.cartStoreId,     //當前購物車StoreId
            mealChoiceListTable: Number(this.$route.query.takeoutId) > 0 ? 'order_record_meal_choiceList' : 'shopping_cart_meal_choiceList',      //餐點選項資料表（sqlite）
            mealDataTable: Number(this.$route.query.takeoutId) > 0 ? 'order_record_meal_data' : 'shopping_cart_meal_data',    //餐點資料資料表（sqlite）
            isShowDialog: false,    //確定離開對話框
            nextRoute: null,        //繼續下一頁
            loadMaskTime: null,     //load遮罩計時器
            //挑選其他餐期時間
            isOpenPickTime: false,
            storeInfo: {},
            removeSubscribe: {},
            reservationTime: this.$route.query.reservationTime ? this.$route.query.reservationTime : "",//目前只有從購物車選完預點菜單異動時會傳
            timeoutID: 0,
            isStopLoading: false,
            isCordova: this.$public.isCordova(),
            isOnlineOrder: Boolean(sessionStorage.getItem("isOnlineOrder")),
            dataObject: {},
            isTableOrderAddItem: false,
            orderId: 0,
            isShowClearCartDialog: false,
            tableId: 0,
            tableNo: "",
            isGoBack: false,
            isCached: false,
            selectItem: {},
            selectIndex: 0,
            isShowCheckDialog: false,
            mealCount: 0,

            analytics: null,
        }
    },
    created() {
        sessionStorage.removeItem('isOnlineOrder');
        if(!this.isCordova) {
            if (typeof this.$route.query.dataToken === "string" && this.$route.query.dataToken !== "") {
                try {
                    let dataObject = this.$crypto.uriComponentToObject(this.$route.query.dataToken)
                    if (dataObject.usedType === constDefine.QRCodeUsedType.TableOrderAddItem) {

                        dataObject.routePath = this.$route.path;
                        dataObject.isChecked = true
                        dataObject.isTableOrderAddItem = true

                        let newDataObject = {
                            ...dataObject,
                            "prototypeObject": {...dataObject},
                        }
                        sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(newDataObject));
                        sessionStorage.setItem('closeBtn', false);
                    } else {
                        this.$router.push({name: 'Error'});
                        return false;
                    }
                }  catch (e) {
                    this.$router.push({name:'Error'});
                    return false;
                }
            }

          try {
            this.dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
            if(this.dataObject.isChecked) {
              this.id = this.dataObject.storeId;
              this.cartStoreId = this.dataObject.storeId;

              if(this.dataObject.isTableOrderAddItem) {
                  this.isTableOrderAddItem = true
                  this.orderId = this.dataObject.orderId
                  this.tableId = this.dataObject.tableId || 0
                  this.analytics = Analytics.getInstance(this.$route, 'QRCodeOrder');
              } else {
                  this.analytics = Analytics.getInstance(this.$route, 'TableOrder');
              }
            } else {
              if(this.dataObject.routePath) {
                this.$router.push({path: this.dataObject.routePath})
              } else {
                this.$router.push({name:'Error'});
              }
              return false;
            }
          } catch (e) {
            if(process.env.VUE_APP_MODE !== "debug") {
              this.$router.push({name:'Error'});
              return false;
            } else {
              sessionStorage.setItem("isOnlineOrder", true);
              this.isOnlineOrder = true;
                this.analytics = Analytics.getInstance(this.$route, 'OnlineOrder');
            }
          }
        } else {
            this.analytics = Analytics.getInstance(this.$route, 'OnlineOrder');
        }

        // 有快照且是來自'OrderDetail','OrderCart'的話就用快照的資料，不是的話就重撈
        // 再次下定回到這頁時，因為沒快取，所以也是跑重撈
        if (!notNull(this.$store.state.pageSnapshot[this.$route.name])) {
            this.setupData();
        } else {
            let snapshotdata = this.$store.state.pageSnapshot[this.$route.name];
            for (const key in snapshotdata) {
                if (Object.hasOwnProperty.call(snapshotdata, key)) {
                    if (key!=='cartStoreId') {
                        const element = snapshotdata[key];
                        this[key] = element;
                    }
                }
            }
            this.$store.watch((state, getter) => {
                return state.cartStoreId;
            }, (newVal) => {
                this.cartStoreId = newVal;
            });

            this.takeAmountRefresh(this.posMenuData);

            //菜單不一樣時要重抓
            if(this.posMenuId !== this.$store.state.orderStoreInfo.posMenuId) {
              this.storeInfo = this.$store.state.orderStoreInfo
              this.setReservationData()
            } else {
              this.storeInfo = this.$store.state.orderStoreInfo
            }

            // 渲染完成後等一下才捲到目標位置
            this.$nextTick(function () {
                if (this.scrollTop !== '') {
                    let finish = false;
                    let count = 0;
                    this.timeoutID = setInterval(() => {
                        this.$refs.order.scrollTop = this.scrollTop
                        if (notNull(this.$refs.sideBar)) {
                            this.$refs.sideBar.scrollTo(this.scrollLeft, 0);
                        }
                        this.scrollTop = '';
                        finish = true;
                        count = count + 1;
                        if (finish || count > 200) {
                            window.clearInterval(this.timeoutID);
                        }
                    }, 20);
                }
            });

        }
        // // 不管有沒有用到快照都要清掉
        this.$store.commit("savePageSnapshot",{routeName:this.$route.name,variable:undefined});
    },
    mounted() {
        let self = this;
        self.removeSubscribe = self.$store.subscribe((mutation, state) => {
            if (mutation.type === mutationTypes.setOrderStoreInfo) {
                self.storeInfo = state.orderStoreInfo
            }
        })

        let callback = (resultSet) => {
            self.mealCount = self.isCordova ? resultSet.rows.length : resultSet.length;
        }

        if (self.isCordova) {
            self.$sqlite.query('select * from ' + self.mealChoiceListTable, [], callback)
        } else {
            self.$sqlite.queryDB(self.mealChoiceListTable, "", "", callback)
        }
    },
    destroyed() {
        this.isGoBack = false
        this.removeSubscribe()
        if (this.timeoutID !== 0) {
            window.clearInterval(this.timeoutID);
        }
    },
    methods: {
        scrollEvent() {
            //偵測區塊捲動的高度
            this.scrollTop = this.$refs.order.scrollTop
            //偵測banner的高度
            let HH = document.getElementById("bannerBrand").offsetHeight - 60
            if (this.scrollTop > HH) {
                this.isActive = true
            }
            if (this.scrollTop <= HH) {
                this.isActive = false
            }

            //獲取有幾個容器
            const sections = this.$refs.anchorId;

            for (let i = sections.length - 1; i >= 0; i--) {
                if (this.scrollTop >= sections[i].offsetTop - 200) {
                    this.selectedTab = i
                    const container = this.$refs.sideBar;
                    const targetElement = this.$refs.nav[i];
                    //按鈕捲動到中間
                    if (container && targetElement) {
                        const containerRect = container.getBoundingClientRect().left;
                        const elementRect = targetElement.getBoundingClientRect().left;
                        const scrollOffset = elementRect - containerRect + container.scrollLeft - 150;
                        container.scrollTo({
                            left: scrollOffset,
                            behavior: 'smooth',
                        });
                    }
                    break;

                }
            }
        },
        setupData(){
            // this.isLoading = true;
            this.starLoading();
            //店家資訊
            this.$http.fetch`GetStoreMenuAndOrderSetting${{
                'storeId': this.id,
                'offset': 0,
                'pageSize': this.pageSize,
                'reservationTime': this.reservationTime,
                'isTableOrderAddItem': this.isTableOrderAddItem,
                'orderId': this.orderId,
                'tableId': this.tableId,
            }}
            ${json => {
                if(json.status) {
                  this.storeInfo = json.data.storeInfo
                  this.brandName = json.data.storeInfo.brandName;
                  this.storeName = json.data.storeInfo.storeName;
                  this.storeImage = json.data.storeInfo.imgUrl;
                  this.isAnnouncement = json.data.storeInfo.isAnnouncement;
                  this.announcement = json.data.storeInfo.announcement;
                  this.tableNo = json.data.tableNo || '';

                  this.posMenuTypeId = json.data.menuData.firstPosMenuTypeId;
                  this.menuName = json.data.menuData.menuName;
                  this.posMenuList = json.data.menuData.menuTypeList;
                  this.posMenuData = json.data.menuDetailList;

                  this.posMenuId = json.data.menuData.id
                  this.storeInfo.posMenuId = json.data.menuData.id

                  let datePeriodData = utilDate.getDatePeriodList(new Date(), this.storeInfo.reservationDay)
                  this.$store.commit(mutationTypes.setPickTimeData, {
                    dateList: datePeriodData.dateList,
                    periodList: datePeriodData.periodList,
                  });

                  if(this.reservationTime !== "" &&
                      (typeof this.$store.state.orderStoreInfo.reservationTime !== "undefined" && this.$store.state.orderStoreInfo.reservationTime !== "")) {

                    this.storeInfo.reservationTime = this.$store.state.orderStoreInfo.reservationTime
                    this.storeInfo.reservationType = this.$store.state.orderStoreInfo.reservationType
                    this.storeInfo.reservationDateIndex = this.$store.state.orderStoreInfo.reservationDateIndex
                    this.storeInfo.reservationPeriodIndex = this.$store.state.orderStoreInfo.reservationPeriodIndex
                    this.storeInfo.reservationTitle = this.$store.state.orderStoreInfo.reservationTitle
                  } else {
                    this.storeInfo.reservationTime = ""
                    this.storeInfo.reservationType = this.storeInfo.defaultReservationType
                    this.storeInfo.reservationDateIndex = 0
                    this.storeInfo.reservationPeriodIndex = 0
                  }

                  if (json.data.menuData.menuTypeList.length===0) {
                    let nextTime = new Date(json.data.menuData.nextMenuTime);
                    let nowTime = new Date;
                    let referNextDate = new Date(nextTime.getFullYear(),nextTime.getMonth(),nextTime.getDate());
                    let referNowDate = new Date(nowTime.getFullYear(),nowTime.getMonth(),nowTime.getDate());
                    let subDay = (referNextDate-referNowDate) / 1000 / 60 / 60 / 24;
                    let nowTimeDay = nowTime.getDay();
                    let nextTimeHours = nextTime.getHours();
                    let nextTimeMinutes = nextTime.getMinutes();
                    let nextTimeDay = nextTime.getDay();
                    let nextTimeStr = (nextTimeHours>9?nextTimeHours:'0'+nextTimeHours)+':'+(nextTimeMinutes>9?nextTimeMinutes:'0'+nextTimeMinutes);
                    if (subDay===1) {
                      nextTimeStr = '明天'+nextTimeStr;
                    }else if(subDay>1){
                      let weekMap = [
                        '日','一','二','三','四','五','六'
                      ];
                      nextTimeStr = '禮拜'+weekMap[nextTimeDay]+nextTimeStr;
                      if (nowTimeDay+subDay>7) {
                        for (let index = 1; index < (nowTimeDay+subDay)/7; index++) {
                          nextTimeStr = '下'+nextTimeStr;
                        }
                      }
                    }
                    //避免是預設時間導致顯示異常
                    this.nextTimeTip = 1000 > nextTime.getFullYear() ? '店家休息中' : 'Oh!目前無法點餐<br>將於' + nextTimeStr+'開放點餐';
                  }

                  this.$store.commit(mutationTypes.setOrderStoreInfo, this.storeInfo);

                  if(this.isTableOrderAddItem && this.orderId > 0 && typeof json.data.token !== "undefined" && json.data.token !== "") {
                      this.$auth.setAdminToken(this.$crypto.decryptText(json.data.token));
                  }

                  this.stopLoad();
                  // 一次撈所有類別跟明細了，所以不用了
                  // this.setupDataScroll = true;
                } else {
                    this.stopLoad();
                    this.$public.showNotify(json.message, false);
                    if(json.data.isInvalid) {
                        this.brandName = json.data.storeInfo.brandName;
                        this.storeName = json.data.storeInfo.storeName;
                        this.storeImage = json.data.storeInfo.imgUrl;

                        this.clearCart(true);
                        this.nextTimeTip = json.message
                    }
                }
            }}`;
        },
        setPosMenuData(){
            // this.isLoading = true;
            this.isStopLoading = true;
            this.starLoading();
            this.$http.fetch`GetPosMenuTypeDetail${{
                'storeId': this.id,
                'menuTypeId': this.posMenuTypeId,
                'offset': this.currentPage,
                'pageSize': this.pageSize,
            }}
            ${json => {
                if (notNull(json.data)) {
                    // json.data.map(function(item){item.takeAmount = 500; return item;});
                    if (this.currentPage === 0) {
                        this.posMenuData = json.data.dataList;
                    }else{
                        this.posMenuData.tmz_load_push(...json.data.dataList);
                    }
                    if (this.infiniteLoadingListState !== '') {
                        if (json.data.dataList.length >= this.pageSize) {
                            this.infiniteLoadingListState.loaded();
                        }else{
                            this.infiniteLoadingListState.complete();
                        }
                    }
                    // this.isLoading = false;
                    this.isStopLoading = false;
                    this.stopLoad();
                } else {
                  this.infiniteLoadingListState.complete();
                //   this.isLoading = false;
                  this.isStopLoading = false;
                  this.stopLoad();
                }
            }}`;
        },
        setupDataScrollAct($state){
            // if (this.isLoading === false) {
            if (this.isStopLoading === false) {
                this.infiniteLoadingListState = $state;
                this.currentPage ++;
                this.setPosMenuData();
            }
        },
        changeMenu(index){
            const container = this.$refs.order;
            const targetElement = this.$refs.anchorId[index];

            if (container && targetElement) {
                const containerTop = container.getBoundingClientRect().top;
                const elementTop = targetElement.getBoundingClientRect().top;
                const scrollOffset = elementTop - containerTop + container.scrollTop - 115;

                //從 CSS 獲取值裝置瀏海高度
                const safeAreaInsetTop = parseFloat(
                    getComputedStyle(document.documentElement).getPropertyValue('--safe-area-top') || 0
                );

                container.scrollTo({
                    top: scrollOffset - safeAreaInsetTop,
                    behavior: 'smooth',
                });
            }
        },
        //洗出所有餐點的數量
        takeAmountRefresh(newVal) {
            // this.isLoading = true;
            this.starLoading();
            try {
                //判斷當前顯示的店家跟購物車上的店家一樣，或是修改訂單
                if (this.cartStoreId === this.id || this.takeoutId !== 0) {
                    for (const mealKey in newVal) {
                        if (Object.hasOwnProperty.call(newVal, mealKey)) {
                            const meal = newVal[mealKey];

                            let callback = (resultSet) => {
                                let amount = 0;
                                let length = this.isCordova ? resultSet.rows.length : resultSet.length;

                                if (length > 0) {
                                    for (let index = 0; index < length; index++) {
                                        let rowsItem = this.isCordova ? resultSet.rows.item(index) : resultSet[index];

                                        amount += rowsItem.amount;
                                    }
                                }
                                this.$set(this.takeAmountMapMeal, mealKey, amount);
                                // this.takeAmountMapMeal[mealKey] = amount;
                                this.$forceUpdate();
                            }

                            if (this.isCordova) {
                                this.$sqlite.query('select id,amount,meal_id from ' + this.mealChoiceListTable + ' WHERE meal_id = ?', [meal.posFoodId], callback);
                            } else {
                                this.$sqlite.queryDB(this.mealChoiceListTable, "meal_id", meal.posFoodId, callback);
                            }

                        }
                    }
                }
            } catch (e) {
                if(!this.isCordova) {
                    this.$router.go(0);
                }
            }
            // this.isLoading = false;
            this.stopLoad();
        },
        delClick(item) {
            if (this.isCordova) {
                this.$sqlite.delete('delete from ' + this.mealChoiceListTable + '  where meal_id = ?', [item.posFoodId], function (resultSet) {
                });
                this.$sqlite.delete('delete from ' + this.mealDataTable + '  where meal_id = ?', [item.posFoodId], function (resultSet) {
                });
            } else {
                this.$sqlite.deleteDB(this.mealChoiceListTable, "meal_id", item.posFoodId, function (resultSet) {
                });
                this.$sqlite.deleteDB(this.mealDataTable, "meal_id", item.posFoodId, function (resultSet) {
                });
            }

            this.takeAmountRefresh(this.posMenuData);
        },
        checkCart() {
            if (this.isCordova) {
                this.$sqlite.query('select SUM(amount),SUM(choicePrice) from ' + this.mealChoiceListTable, [], (resultSet) => {
                    if (resultSet.rows.length > 0) {
                        this.totalAmount = resultSet.rows.item(0)['SUM(amount)'];
                        this.totalPrice = resultSet.rows.item(0)['SUM(choicePrice)'];
                    }
                });
            } else {
                this.$sqlite.queryDB(this.mealChoiceListTable, "", "", (resultSet) => {
                    let totalAmount = 0;
                    let totalPrice = 0;
                    let choiceStoreId = 0;
                    if (resultSet.length > 0) {
                        for (let i = 0; i < resultSet.length; i++) {
                            totalAmount += resultSet[i].amount;
                            totalPrice += resultSet[i].choicePrice;
                            choiceStoreId = resultSet[i].stroe_id;
                        }
                    }

                    if (choiceStoreId === 0 || choiceStoreId === this.cartStoreId) {
                        this.totalAmount = totalAmount;
                        this.totalPrice = totalPrice;
                    } else {
                        this.clearCart(false)
                    }
                })
            }
        },
        onCommDialogClose(result){
            if (result) {
                this.nextRoute();
            }
            else{
                this.isShowDialog = false;
                this.nextRoute(false);
            }
        },
        onCommClearCartDialogClose(result){
            if (result) {
                this.analytics.sendEvent(Analytics.EVENTS.CLEAR_CART);
                this.clearCart(true);
                this.takeAmountRefresh(this.posMenuData);
            }
            this.isShowClearCartDialog = false
        },
        //打開預點時間
        openPickTime() {
            if(!this.storeInfo.isDeliveryReservation && !this.storeInfo.isTakeoutReservation) {
              this.$public.showNotify('不開放預點');
            } else {
              this.isOpenPickTime = true
            }
        },
        closePickTime(obj){
          if (obj.isChangePosMenu) {
            this.setReservationData()
          }
          this.isOpenPickTime = false
        },
        starLoading(){
          this.loadMaskTime = setTimeout(() => {
            this.isLoading = true;
          }, 50);
        },
        stopLoad(){
          this.isLoading = false;
          if (this.loadMaskTime) {
            clearTimeout(this.loadMaskTime)
          }
        },
        setReservationData() {
          this.isLoading = true;
          this.$http.fetch`GetStoreMenuAndOrderSetting${{
            'storeId':this.id,
            'offset': 0,
            'pageSize': this.pageSize,
            'reservationTime': this.storeInfo.reservationTime,
            'isTableOrderAddItem': this.isTableOrderAddItem,
            'orderId': this.orderId,
          }}
            ${json => {
            if(json.status) {
              this.posMenuTypeId = json.data.menuData.firstPosMenuTypeId;
              this.menuName = json.data.menuData.menuName;
              this.posMenuList = json.data.menuData.menuTypeList;
              this.posMenuData = json.data.menuDetailList;

              this.posMenuId = json.data.menuData.id
              this.storeInfo.posMenuId = json.data.menuData.id;

              this.$store.commit(mutationTypes.setOrderStoreInfo, this.storeInfo);

              // 一次撈所有類別跟明細了，所以不用了
              // this.setupDataScroll = true;
            } else {
              this.$public.showNotify(json.message, false);

              if(json.data.isInvalid) {
                    this.brandName = json.data.storeInfo.brandName;
                    this.storeName = json.data.storeInfo.storeName;
                    this.storeImage = json.data.storeInfo.imgUrl;

                    this.clearCart(true);
                    this.nextTimeTip = json.message
              }
            }

            this.checkCart();
            this.isLoading = false;

          }}`;
        },
        clearCart(isCheck = false) {
            this.$public.clearCart(this);
            this.$store.commit("clearCartPageSnapshot");
            this.$store.commit("savePageSnapshot", {routeName: "OrderList", variable: undefined});

            if (isCheck) {
                this.checkCart()
            }

            if (this.isShowCheckDialog) {
                this.cartStoreId = 0
                this.mealCount = 0
                this.isShowCheckDialog = false
            }
        },
        navigationBarEvent(obj) {
            let event = obj.event
            if(event === "clearCart") {
                this.isShowClearCartDialog = true
            }
        },
        menuEvent(obj, item, index) {
            let self = this
            let event = obj.event
            self.selectItem = item
            self.selectIndex = index
            if (event === "updateAmount") {
                if (item.orderType === 1) {
                    self.getPosFoodDetail(obj)
                } else {
                    self.analytics.recordViewed(item.posFoodId, 'plusButtonClicked');
                    self.$refs[`posFoodId_${obj.posFoodId}`][0].goDetail()
                }
            }
        },
        getPosFoodDetail(obj) {
            let self = this;
            let posFoodId = obj.posFoodId

            let callback = function (resultSet) {
                let length = self.isCordova ? resultSet.rows.length : resultSet.length;
                self.isCached = false;
                if (length > 0) {
                    let dataJson = self.isCordova ? resultSet.rows.item(0).data_json : resultSet[0].data_json;
                    self.isCached = true;
                    setData(JSON.parse(dataJson));
                } else {
                    self.isLoading = true;
                    self.$http.fetch`GetPosFoodDetail${{
                        'posFoodId': posFoodId,
                        'isTableOrderAddItem': self.isTableOrderAddItem,
                        'orderId': self.orderId,
                        'storeId': self.id,
                        'orderListGetPosFoodDetail': true,//暫時方便統計使用次數用，不用後可刪
                    }}
                    ${json => {
                        self.isLoading = false;
                        if (notNull(json.data)) {
                            setData(json.data);
                        } else {
                            self.$public.showNotify(json.message, json.status);
                        }
                    }}`;
                }
            }

            if (self.isCordova) {
                self.$sqlite.query("select * from " + self.mealDataTable + " where meal_id = ?", [posFoodId], callback);
            } else {
                self.$sqlite.queryDB(self.mealDataTable, "meal_id", posFoodId, callback);
            }

            let setData = function (data) {
                let posFood = data;
                let orderType = data.posFoodInfo.orderType;
                let mealCombination = data.dataList;

                // 單點帶入選項組合
                if (orderType === 1) {
                    // 移除餐點註記
                    mealCombination = mealCombination.filter(function (item) {
                        return item.noteType !== 1 && item.posGoodsNoteDetailList.length > 0;
                    });
                }

                posFood.dataList = mealCombination;

                if (posFood.dataList.length > 0 || orderType === 2) {
                    self.$refs[`posFoodId_${posFoodId}`][0].goDetail()
                } else {
                    self.posMenuData[self.selectIndex].isEmptyNote = true
                    if (obj.action === "openAmount") {
                        let amount = self.takeAmountMapMeal[self.selectIndex] || 0;

                        self.$set(self.takeAmountMapMeal, self.selectIndex, 0);
                        self.$nextTick(() => {
                            self.$set(self.takeAmountMapMeal, self.selectIndex, amount);
                        });
                    } else {
                        self.updateCart(obj, posFoodId, posFood)
                    }
                }
            }
        },
        updateCart(obj, posFoodId, posFood) {
            let self = this;
            let action = obj.action
            let amount = self.takeAmountMapMeal[self.selectIndex] || 0
            let price = self.selectItem.onlineOrderPrice

            if (action === "addAmount") {
                amount++
                self.analytics.sendEvent(Analytics.EVENTS.ADD_TO_CART, { foodId: posFoodId });
            } else if (action === "decAmount") {
                amount--
                self.analytics.sendEvent(Analytics.EVENTS.REMOVE_FROM_CART, { foodId: posFoodId });
            }

            //如果當前購物車的StoreId與正在加入的商品的StoreId不同 則跳確認清空購物車彈框
            if ((this.cartStoreId !== 0 && this.cartStoreId !== this.id && this.id !== 0 && this.takeoutId === 0) || (this.mealCount > 0 && this.cartStoreId === 0)) {
                this.isShowCheckDialog = true;
            } else {
                let updateCart = function () {
                    return new Promise(function (resolve, reject) {
                        // 有加入購物車的話，會加進sqlite，加過就不用再加了
                        if (!self.isCached) {
                            if (self.isCordova) {
                                self.$sqlite.insert('insert into ' + self.mealDataTable + ' (meal_id, data_json) values (?, ?);', [posFoodId, JSON.stringify(posFood)], function (resultSet) {
                                });
                            } else {
                                self.$sqlite.insertDB(self.mealDataTable, [{
                                    meal_id: posFoodId,
                                    data_json: JSON.stringify(posFood)
                                }], function (resultSet) {
                                })
                            }
                        }

                        if (self.isCordova) {
                            if (action === "addAmount") {
                                self.$sqlite.query('select id, amount, choicePrice from ' + self.mealChoiceListTable + ' where meal_id = ? and combination_json = ? and text_note = ?', [posFoodId, JSON.stringify([]), ""], function (resultSet) {
                                    // 如果有相同選項組合，就把數量合併
                                    if (resultSet.rows.length > 0) {
                                        let id = resultSet.rows.item(0).id;
                                        let choiceAmount = resultSet.rows.item(0).amount;
                                        choiceAmount++

                                        self.$sqlite.update('UPDATE ' + self.mealChoiceListTable + ' SET amount = ?, choicePrice = ? WHERE id = ?', [choiceAmount, choiceAmount * price, id], function (resultSet) {
                                            resolve();
                                        });
                                    } else {
                                        // 沒有的話就新增
                                        self.$sqlite.insert('insert into ' + self.mealChoiceListTable + ' (meal_id, amount, combination_json, text_note, choicePrice) values(?, ?, ?, ?, ?)', [posFoodId, 1, JSON.stringify([]), "", price], function (resultSet) {
                                            resolve();
                                        })
                                    }
                                });
                            } else if (action === "decAmount") {
                                self.$sqlite.query('select id, amount, choicePrice from ' + self.mealChoiceListTable + ' where meal_id = ?', [posFoodId], function (resultSet) {

                                    if (resultSet.rows.length > 0) {
                                        let index = resultSet.rows.length - 1
                                        let id = resultSet.rows.item(index).id;
                                        let choiceAmount = resultSet.rows.item(index).amount;
                                        choiceAmount--

                                        if (choiceAmount > 0) {
                                            self.$sqlite.update('UPDATE ' + self.mealChoiceListTable + ' SET amount = ?, choicePrice = ? WHERE id = ?', [choiceAmount, choiceAmount * price, id], function (resultSet) {
                                                resolve();
                                            });
                                        } else {
                                            self.$sqlite.delete('delete from ' + self.mealChoiceListTable + '  where id = ?', [id], function (resultSet) {
                                                resolve();
                                            });
                                        }
                                    }
                                });
                            }
                        } else {
                            if (action === "addAmount") {
                                self.$sqlite.queryDB(self.mealChoiceListTable, "meal_id", posFoodId, function (resultSet) {
                                    let isExist = false;
                                    let updateItem = {}

                                    for (let i = 0; i < resultSet.length; i++) {
                                        let item = resultSet[i];
                                        if (item.text_note === "" && item.combination_json === JSON.stringify([])) {
                                            isExist = true;
                                            updateItem = item
                                            break;
                                        }
                                    }

                                    if (isExist) {
                                        updateItem.amount++
                                        updateItem.choicePrice = updateItem.amount * price;
                                        self.$sqlite.updateDB(self.mealChoiceListTable, [updateItem], function (resultSet) {
                                            resolve();
                                        })
                                    } else {
                                        self.$sqlite.insertDB(self.mealChoiceListTable, [{
                                            meal_id: posFoodId,
                                            amount: 1,
                                            combination_json: JSON.stringify([]),
                                            text_note: "",
                                            choicePrice: price,
                                            stroe_id: self.id
                                        }], function (resultSet) {
                                            resolve();
                                        })
                                    }
                                })
                            } else if (action === "decAmount") {
                                self.$sqlite.queryDB(self.mealChoiceListTable, "meal_id", posFoodId, function (resultSet) {
                                    if (resultSet.length > 0) {
                                        let updateItem = resultSet[resultSet.length - 1];
                                        updateItem.amount--
                                        if (updateItem.amount > 0) {
                                            updateItem.choicePrice = updateItem.amount * price;
                                            self.$sqlite.updateDB(self.mealChoiceListTable, [updateItem], function (resultSet) {
                                                resolve();
                                            })
                                        } else {
                                            self.$sqlite.deleteDB(self.mealChoiceListTable, "", updateItem.id, function (resultSet) {
                                                resolve();
                                            });
                                        }
                                    }
                                })
                            }
                        }

                        //設定當前購物車的StoreId（排除沒有設定的時候，已選過的）
                        if (action === "addAmount" && self.id !== 0 && self.takeoutId === 0) {
                            self.$store.commit('setCartStoreId', self.id);
                            self.cartStoreId = self.id
                        }
                    });
                }

                updateCart().then(() => {
                    if (obj.event === "updateAmount") {
                        self.$set(self.takeAmountMapMeal, self.selectIndex, amount);

                        if( amount === 0) {
                            self.delClick(self.selectItem)
                        }
                    }
                });
            }
        },
        track() {
            this.$nextTick(() => {
                const mealEls = this.$refs.meals?.querySelectorAll('[data-food-id]');

                if (mealEls && mealEls.length > 0) {
                    this.analytics.initViewTracker({
                        elements: mealEls,
                        getFoodId: el => Number(el.dataset.foodId),
                        delay: 2000,
                        threshold: 0.7,
                    });
                }
            });
        },
    },
    watch:{
        posMenuData:{
                handler:function (newVal,oldVal) {
                    this.takeAmountRefresh(newVal);
                    this.track();
                },
                deep: true ,
                immediate: true,
        },
        takeAmountMapMeal:{
            handler:function (newVal,oldVal) {
                this.checkCart();
            },
            deep: true ,
            immediate: true,
        },
    },
    beforeRouteLeave: function(to, from, next) {
        const currentPage = this.analytics?._page;
        const toRouteName = to.name;
        const metadata = this.analytics.getLeavePageMetadata();
        this.analytics.sendEvent(Analytics.EVENTS.LEAVE_PAGE, metadata);
        Analytics.destroyInstance(currentPage, toRouteName);

        if (['OINPay', 'PayPassword'].indexOf(to.name) !== -1 || (['OrderCart'].indexOf(to.name) !== -1 && this.totalAmount <= 0)) {
            this.isGoBack = true;
            this.$router.go(-1);
            setTimeout(() => {
                if(this.isGoBack) {
                    this.$router.go(-1);
                }
            })
            return false;
        }

        // 如果是'OrderDetail','OrderCart'的話就記住快照
        if (['OrderDetail','OrderCart', "TableOrderRecord", "TableOrderComplete"].indexOf(to.name) !== -1) {
            let variable = {};
            for (const key in this._data) {
                if (Object.hasOwnProperty.call(this._data, key)) {
                    const element = this._data[key];
                    variable[key] = element;
                }
            }
            variable.scrollTop = this.$refs.order.scrollTop;
            variable.scrollHeight = this.$refs.order.scrollHeight;
            if(notNull(this.$refs.sideBar)) {
              variable.scrollLeft = this.$refs.sideBar.scrollLeft;
            }
                this.$store.commit("savePageSnapshot",
                {
                    routeName: from.name,
                    variable: variable,
                },
            );
        }
        if (!["OrderDetail","OrderCart","OrderRecordList", "TableOrderRecord", "TableOrderComplete"].includes(to.name)) {
            if (this.id===this.cartStoreId&&this.cartStoreId!==0 && this.totalAmount > 0) {
                this.isShowDialog = true;
                this.nextRoute = next;
                return;
            }else{
                next();
            }
        }
        next();
    },
}
</script>

<style lang="less" scoped src="../../less/order.less"/>